import { z } from 'zod';

import { AdvisorDataZod } from './advisor-data';

import { EmployerDataZod } from 'types/zod/employer-data';
import { ParticipantZod } from 'types/zod/participant';

export const AdvisorParticipantZod = ParticipantZod.and(
    z.object({
        systemRoles: z.array(z.union([z.literal('advisor'), z.literal('admin')])).optional(),
        couponName: z.string().optional(),
        directInvoicing: z.boolean().optional(),
        employerData: EmployerDataZod.optional(),
        advisorData: AdvisorDataZod.optional(),
    }),
);
export type AdvisorParticipant = z.infer<typeof AdvisorParticipantZod>;
